export default "__VITE_ASSET__DP7pPm$n__"